import { useEffect } from 'react';

export function useExpandTelegramApp() {
  useEffect(() => {
    window.Telegram?.WebApp?.expand?.();
  }, []);
}
